<p>
    Rocket Strike is a survival action platformer. Outlast your opponent in a
    rocket survival! For 1-4 players, but multiplayer is strongly recommended!
</p>

<p>Rocket Strike was released as a single player game on Google Play and as local multiplayer game for web browsers. I built a more streamlined version with updated assets, integrated achievments and leaderboards for Y8.com.</p>